export const encodePrivateKey = (file: File | null): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve("");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result && typeof reader.result === "string") {
        resolve(btoa(reader.result));
      } else {
        reject("秘密鍵の読み込みに失敗しました");
      }
    };
    reader.onerror = () => reject("秘密鍵のエンコードに失敗しました");
    reader.readAsText(file);
  });
};
